<template>
  <!-- ===== 顶部导航 ===== -->
  <!-- ===== 顶部导航 ===== -->
  <header class="navbar">
    <div class="nav-container">
      <div class="nav-logo" @click="goHome">
        <span class="logo-icon">
          <img src="../assets/logo.png" alt="AETRIVOL" style="width: 75px" />
        </span>
        <div style="display: flex; flex-direction: column">
          <span class="logo-text">AETRIVOL</span>
          <span class="logo-text2">Innovate | Soar | Transform</span>
        </div>
      </div>
      <div
        style="display: flex; gap: 20px; align-items: flex-end; height: 50px"
      >
        <nav class="nav-menu">
          <router-link
            to="/"
            class="nav-link"
            :class="{ active: isActive('/') }"
            >{{ $t("head.index") }}</router-link
          >
          <router-link
            to="/info"
            class="nav-link"
            :class="{ active: isActive('/info') }"
            >{{ $t("head.product") }}</router-link
          >
          <router-link
            to="/rental"
            class="nav-link"
            :class="{ active: isActive('/rental') }"
            >{{ $t("head.rental") }}</router-link
          >
          <router-link
            to="/about"
            class="nav-link"
            :class="{ active: isActive('/about') }"
            >{{ $t("head.about") }}</router-link
          >
        </nav>

        <!-- 右侧：语言切换 + 用户头像 -->
        <div class="nav-actions">
          <!-- ===== 语言选择下拉框（封装组件） ===== -->
          <LangSwitcher @language-changed="onLanguageChanged" />

          <!-- ===== 用户头像下拉框 ===== -->
          <div
            class="user-dropdown"
            @mouseenter="openUserDropdown"
            @mouseleave="closeUserDropdown"
          >
            <div class="user-avatar" @click="onMember()">
              <img
                v-if="userInfo.avatar"
                :src="userInfo.avatar"
                alt="用户头像"
              />
              <svg
                v-else
                class="avatar-default"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span class="avatar-badge"></span>
            </div>
            <!-- 下拉菜单 -->
            <transition name="fade">
              <div v-show="isUserDropdownOpen" class="dropdown-menu">
                <!-- 个人信息区域 -->
                <div class="dropdown-user-info">
                  <div class="dropdown-avatar">
                    <img
                      v-if="userInfo.avatar"
                      :src="userInfo.avatar"
                      alt="头像"
                    />
                    <svg
                      v-else
                      class="avatar-default"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                      ></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                  <div class="dropdown-user-detail">
                    <div class="username">
                      {{ userInfo.first_name }} {{ userInfo.last_name }}
                    </div>
                    <div class="user-email">UID: {{ userInfo.uid }}</div>
                  </div>
                </div>
                <div class="dropdown-divider"></div>
                <!-- 菜单列表 -->
                <ul class="dropdown-list">
                  <li>
                    <div class="dropdown-item" @click="onUrl('Member')">
                      <i class="iconfont icon-gerenzhongxin"></i
                      >{{ $t("menu.profile") }}
                    </div>
                  </li>
                  <li>
                    <div
                      class="dropdown-item"
                      @click="onUrl('Setting', { tab: 'security' })"
                    >
                      <i class="iconfont icon-anquan"></i
                      >{{ $t("menu.security") }}
                    </div>
                  </li>
                  <li>
                    <div class="dropdown-item" @click="onUrl('Setting')">
                      <i class="iconfont icon-shezhi"></i
                      >{{ $t("menu.settings") }}
                    </div>
                  </li>
                </ul>
                <div class="dropdown-divider"></div>
                <ul class="dropdown-list">
                  <li>
                    <div
                      class="dropdown-item"
                      @click="onUrl('Member', { tab: 'products' })"
                    >
                      <i class="iconfont icon-chanpinliebiao"></i
                      >{{ $t("menu.products") }}
                    </div>
                  </li>
                  <li>
                    <div
                      class="dropdown-item"
                      @click="onUrl('Member', { tab: 'deposits' })"
                    >
                      <i class="iconfont icon-cunru"></i>
                      {{ $t("menu.deposits") }}
                    </div>
                  </li>
                  <li>
                    <div
                      class="dropdown-item"
                      @click="onUrl('Member', { tab: 'withdraws' })"
                    >
                      <i class="iconfont icon-tiqu"></i>
                      {{ $t("menu.withdraws") }}
                    </div>
                  </li>
                  <li>
                    <div
                      class="dropdown-item"
                      @click="onUrl('Member', { tab: 'walletLog' })"
                    >
                      <i class="iconfont icon-licaijiaoyi"></i>
                      {{ $t("menu.walletLog") }}
                    </div>
                  </li>
                </ul>

                <div class="dropdown-divider"></div>
                <div class="dropdown-footer">
                  <button class="btn-logout" @click="logout">
                    {{ $t("menu.logout") }}
                  </button>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import consts from "@/utils/consts";
import LangSwitcher from "@/components/LangSwitcher.vue";

export default {
  name: "HeadMenu",
  components: {
    LangSwitcher,
  },
  data() {
    return {
      // 用户下拉控制
      isUserDropdownOpen: false,
      // 用户信息
      userInfo: {},
    };
  },

  created() {
    this.getUserInfo();
  },
  methods: {
    // 判断当前路由是否匹配菜单项
    isActive(path) {
      return this.$route.path === path;
    },
    goHome() {
      this.$router.push({ name: "Index" }).catch(() => {});
    },


    // ===== 用户下拉菜单跳转 =====
    onUrl(name, query = {}) {
      // 关闭用户下拉框
      this.isUserDropdownOpen = false;
      // 跳转到对应路由（捕获重复导航错误，避免控制台报错）
      if (Object.keys(query).length) {
        this.$router.push({ name, query }).catch(() => {});
      } else {
        this.$router.push({ name }).catch(() => {});
      }
    },

    onMember() {
      this.$router.push({ name: "Member" }).catch(() => {});
    },

    // ===== 用户下拉控制 =====
    openUserDropdown() {
      // this.isUserDropdownOpen = true;
    },
    closeUserDropdown() {
      this.isUserDropdownOpen = false;
    },

    // ===== 语言切换回调 =====
    onLanguageChanged(code) {
      // 语言切换后触发页面刷新或重新渲染
      this.$emit("language-changed", code);
    },
    async getUserInfo() {
      const user = await this.$api.user.getUserInfo();
      if (user.code === 0) {
        this.userInfo = user.data;
      }
    },
    logout() {
      localStorage.removeItem(consts.KEY_TOKEN);
      localStorage.removeItem(consts.KEY_INFO);
      this.$message.success(this.$t("menu.logoutSuccess"));
      this.$router.push({ name: "Login" }).catch(() => {});
    },

  },
};
</script>

<style scoped>
/* ===== 导航栏 ===== */
.navbar {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding: 0 20px;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.nav-logo {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  cursor: pointer;
}

.logo-icon {
  font-size: 28px;
  padding-top: 5px;
  display: flex;
}

.logo-text {
  font-size: 27px;
  font-weight: 800;
  background: linear-gradient(135deg, #00b4ff, #7c3aed);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.logo-text2 {
  font-size: 10px;
  font-weight: 800;
  background: linear-gradient(135deg, #0477a7, #7fbac8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.nav-menu {
  display: flex;
  gap: 32px;
  align-items: center;
}

.nav-link {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 18px;
  font-weight: 500;
  transition: color 0.3s;
  position: relative;
}

.nav-link:hover {
  color: #fff;
}

.nav-link.active {
  color: #00b4ff;
}

.nav-link.active::after {
  content: "";
  position: absolute;
  bottom: -4px;
  left: 0;
  right: 0;
  height: 2px;
  background: #00b4ff;
  border-radius: 2px;
}

/* ===== 右侧用户头像 & 下拉 ===== */
/* .nav-actions {
  display: flex;
  align-items: flex-end;
  gap: 12px;
} */

/* 头像容器 */
.user-dropdown {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
}

.user-avatar {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.2);
  transition: border-color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
}

.user-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  display: block;
}

/* 默认 SVG 头像 */
.avatar-default {
  color: rgba(255, 255, 255, 0.5);
  flex-shrink: 0;
}

.user-avatar:hover {
  border-color: #00b4ff;
}

/* 在线小绿点 (装饰) */
.avatar-badge {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  background: #22c55e;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.9);
}

/* ===== 下拉菜单 ===== */
.dropdown-menu {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  min-width: 260px;
  background: #1a1a2e;
  backdrop-filter: blur(24px);
  background: rgba(20, 20, 35, 0.95);
  border-radius: 16px;
  padding: 12px 0;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transform-origin: top right;
}

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.96) translateY(-8px);
}

/* 用户信息区块 */
.dropdown-user-info {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 4px 16px 12px 16px;
}

.dropdown-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.15);
  flex-shrink: 0;
}

.dropdown-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dropdown-user-detail {
  display: flex;
  flex-direction: column;
}

.username {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  line-height: 1.4;
}

.user-email {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 0.3px;
}

.dropdown-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 6px 16px;
}

/* 菜单列表 */
.dropdown-list {
  list-style: none;
  padding: 4px 0;
  margin: 0;
}

.dropdown-list li {
  padding: 0 8px;
}

.dropdown-list li a,
.dropdown-list li .dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 14px;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  font-size: 14px;
  font-weight: 450;
  transition: all 0.15s ease;
  background: transparent;
  cursor: pointer;
}

.dropdown-list li a:hover,
.dropdown-list li .dropdown-item:hover {
  background: rgba(0, 180, 255, 0.12);
  color: #fff;
}

.menu-icon {
  font-size: 18px;
  line-height: 1;
  width: 24px;
  text-align: center;
  color: rgba(255, 255, 255, 0.4);
}

.dropdown-list li a:hover .menu-icon,
.dropdown-list li .dropdown-item:hover .menu-icon {
  color: #00b4ff;
}

/* 底部退出按钮 */
.dropdown-footer {
  padding: 6px 16px 4px 16px;
}

.btn-logout {
  width: 100%;
  padding: 10px 0;
  background: rgba(255, 70, 70, 0.12);
  border: 1px solid rgba(255, 70, 70, 0.15);
  border-radius: 12px;
  color: #f87171;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
}

.btn-logout:hover {
  background: rgba(255, 70, 70, 0.2);
  border-color: rgba(255, 70, 70, 0.3);
  color: #fca5a5;
}

/* 响应式微调 */
@media (max-width: 768px) {
  .nav-menu {
    display: none;
  }
  .nav-container {
    justify-content: space-between;
  }
}

/* ===== 语言选择器 ===== */
.lang-dropdown {
  position: relative;
  cursor: pointer;
}

.lang-selector {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0px 12px;
  border-radius: 8px;
  /* background: rgba(255, 255, 255, 0.04); */
  /* border: 1px solid rgba(255, 255, 255, 0.06); */
  transition: all 0.3s ease;
  color: rgba(255, 255, 255, 0.7);
}
.lang-selector:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.lang-flag {
  font-size: 18px;
  line-height: 1;
}

/* 圆圈国旗 */
.lang-flag-circle {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
}

.lang-flag-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.lang-name {
  font-size: 17px;
  font-weight: 500;
}

.lang-arrow {
  transition: transform 0.3s ease;
  opacity: 0.5;
}
.lang-dropdown:hover .lang-arrow {
  transform: rotate(180deg);
  opacity: 0.8;
}

/* ===== 语言下拉菜单 ===== */
.lang-dropdown-menu {
  min-width: 200px;
  max-height: 360px;
  overflow-y: auto;
}

.lang-dropdown-menu .dropdown-list li a {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  font-size: 14px;
  transition: all 0.15s ease;
}

.lang-dropdown-menu .dropdown-list li a:hover {
  background: rgba(0, 180, 255, 0.12);
  color: #fff;
}

.lang-dropdown-menu .dropdown-list li a.active {
  background: rgba(0, 180, 255, 0.15);
  color: #00b4ff;
}

.lang-flag-item {
  font-size: 18px;
  line-height: 1;
}

.lang-name-item {
  flex: 1;
  font-weight: 450;
}

.lang-code-item {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.3);
  font-weight: 600;
}

.lang-check {
  color: #00b4ff;
  font-weight: 700;
  font-size: 14px;
}

/* 滚动条美化 */
.lang-dropdown-menu::-webkit-scrollbar {
  width: 4px;
}
.lang-dropdown-menu::-webkit-scrollbar-track {
  background: transparent;
}
.lang-dropdown-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}
.lang-dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* ===== 用户头像下拉 ===== */
.user-dropdown {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
}

.user-avatar {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.2);
  transition: border-color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
}

.user-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  display: block;
}

.user-avatar:hover {
  border-color: #00b4ff;
}

.avatar-badge {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  background: #22c55e;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.9);
}

/* ===== 下拉菜单通用 ===== */
.dropdown-menu {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  min-width: 260px;
  background: #1a1a2e;
  backdrop-filter: blur(24px);
  background: rgba(20, 20, 35, 0.95);
  border-radius: 16px;
  padding: 12px 0;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transform-origin: top right;
}

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.96) translateY(-8px);
}

/* ===== 用户信息区块 ===== */
.dropdown-user-info {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 4px 16px 12px 16px;
}

.dropdown-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.15);
  flex-shrink: 0;
}

.dropdown-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dropdown-user-detail {
  display: flex;
  flex-direction: column;
}

.username {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  line-height: 1.4;
}

.user-email {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 0.3px;
}

.dropdown-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 6px 16px;
}

/* ===== 菜单列表 ===== */
.dropdown-list {
  list-style: none;
  padding: 4px 0;
  margin: 0;
}

.dropdown-list li {
  padding: 0 8px;
}

.dropdown-list li a,
.dropdown-list li .dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 14px;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  font-size: 14px;
  font-weight: 450;
  transition: all 0.15s ease;
  background: transparent;
  cursor: pointer;
}

.dropdown-list li a:hover,
.dropdown-list li .dropdown-item:hover {
  background: rgba(0, 180, 255, 0.12);
  color: #fff;
}

.dropdown-list li a .iconfont,
.dropdown-list li .dropdown-item .iconfont {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.4);
}

.dropdown-list li a:hover .iconfont,
.dropdown-list li .dropdown-item:hover .iconfont {
  color: #00b4ff;
}

/* ===== 底部退出按钮 ===== */
.dropdown-footer {
  padding: 6px 16px 4px 16px;
}

.btn-logout {
  width: 100%;
  padding: 10px 0;
  background: rgba(255, 70, 70, 0.12);
  border: 1px solid rgba(255, 70, 70, 0.15);
  border-radius: 12px;
  color: #f87171;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
}

.btn-logout:hover {
  background: rgba(255, 70, 70, 0.2);
  border-color: rgba(255, 70, 70, 0.3);
  color: #fca5a5;
}

/* ===== 导航栏调整 ===== */
.nav-actions {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .nav-menu {
    display: none;
  }
  .lang-name {
    display: none;
  }
  .lang-selector {
    padding: 6px 10px;
  }
}
</style>
